import { cloneElement, isValidElement } from "react";
import "./css/output.css";
export default function ObjectValue({
  label,
  value,
  children,
  className,
  ...props
}) {
  const computedClassName = ["output", "object-value", ...className.split(" ")]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      {!!label && (
        <>
          <strong>{label}</strong>
          <br />
        </>
      )}
      <div style={{ marginLeft: "8px", marginRight: "8px" }}>
        {children instanceof Function && children({ value })}
        {isValidElement(children) && cloneElement(children, { value })}
      </div>
    </div>
  );
}

ObjectValue.defaultProps = {
  className: "",
};
